// ------------------------------------
// CKEditor
// ------------------------------------
(function () {
  'use strict';

  // Campos CKEditor
  const $CKEditorInputs = $('textarea.cke-input');
  const $CKEditorEmailInputs = $('textarea.cke-input-email');
  const iframelyKey = '7faae7ae7d364351e42288';

  // Só inicia o plugin caso haja algum campo na página
  if ($CKEditorInputs.length > 0 || $CKEditorEmailInputs.length > 0) {
    // Configurações
    const CKEditorConfs = {
      // Layout da barra de opções
      toolbarGroups: [
        { name: 'tools', groups: ['tools'] },
        { name: 'clipboard', groups: ['undo', 'clipboard'] },
        { name: 'styles', groups: ['styles'] },
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'paragraph', groups: ['align', 'list', 'blocks', 'indent', 'bidi', 'paragraph'] },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
        { name: 'forms', groups: ['forms'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] },
      ],
      // Opções ocultas
      removeButtons:
        'Replace,Find,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,HiddenField,Cut,Copy,Paste,PasteText,PasteFromWord,Save,NewPage,ExportPdf,Preview,Print,Templates,autoFormat,CommentSelectedRange,UncommentSelectedRange,AutoComplete,codemirrorAbout,Strike,Superscript,Subscript,CopyFormatting,Outdent,Indent,CreateDiv,BidiRtl,Language,BidiLtr,Anchor,Smiley,SpecialChar,PageBreak,Iframe,HorizontalRule,Styles,Font,FontSize,ShowBlocks,About',
      // Abas ocultas
      removeDialogTabs: 'image:advanced;link:advanced;link:upload',
      // Plugins removidos
      removePlugins: 'image,exportpdf',
      clipboard_handleImages: false,
      // Plugins adicionais
      //extraPlugins: '',
      // Embed provider
      embed_provider:
        '//ckeditor.iframe.ly/api/oembed?api_key=' +
        iframelyKey +
        '&url={url}&callback={callback}&language=pt-BR&iframe=0&consent=0',
      // Idioma
      language: 'pt-br',
      // Altura do editor
      height: 200,
      // Distância da indentação
      indentOffset: 20,
      // Opções do formato do texto
      format_tags: 'p;h2;h3',
      // Configurações do plugin 'autogrow'
      autoGrow_minHeight: 200,
      autoGrow_maxHeight: 500,
      autoGrow_onStartup: true,
      // Configurações do plugin 'image2'
      image2_captionedClass: 'img',
      image2_alignClasses: ['align-left', 'align-center', 'align-right'],
      // Código para upload de imagens
      filebrowserUploadUrl: urlBase + 'plugins/ckeditor/ck_upload.php',
      filebrowserUploadMethod: 'form',
      // Conteúdo permitido (HTML)
      extraAllowedContent: 'style;*[id];*(*);*{*};hr',
      // Codemirror
      codemirror: {
        showSearchButton: false,
        showFormatButton: false,
        showCommentButton: false,
        showUncommentButton: false,
        showAutoCompleteButton: false,
      },
      // Eventos
      on: {
        // Quando o plugin é carregado
        instanceReady: function () {
          $('textarea.cke-input[data-cke-required]').attr('required', '');
          $.each(CKEDITOR.instances, function (instance) {
            const textarea = $('#' + instance);
            const instanceItem = CKEDITOR.instances[instance];
            // Campos obrigatórios (Parsley)
            instanceItem.on('change', function (e) {
              instanceItem.updateElement();
              textarea.parsley().validate();
            });
          });
        },
      },
    };
    // Configurações para mensagens de e-mail
    const CKEditorEmailConfs = {
      // Layout da barra de opções
      toolbarGroups: [
        { name: 'clipboard', groups: ['undo', 'clipboard'] },
        { name: 'styles', groups: ['styles'] },
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'paragraph', groups: ['align', 'list', 'indent', 'blocks', 'bidi', 'paragraph'] },
        { name: 'links', groups: ['links'] },
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
        { name: 'forms', groups: ['forms'] },
        { name: 'insert', groups: ['insert'] },
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] },
      ],
      // Opções ocultas
      removeButtons:
        'About,Maximize,ShowBlocks,Styles,Format,Font,Image,Embed,Html5video,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Anchor,Language,BidiRtl,BidiLtr,CreateDiv,Blockquote,Outdent,Indent,CopyFormatting,Subscript,Superscript,autoFormat,CommentSelectedRange,UncommentSelectedRange,AutoComplete,codemirrorAbout,NewPage,Save,ExportPdf,Preview,Print,Templates,Cut,Paste,Copy,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,HiddenField,Strike',
      // Abas ocultas
      removeDialogTabs: 'image:advanced;link:advanced;link:upload',
      // Plugins removidos
      removePlugins: 'image,exportpdf',
      clipboard_handleImages: false,
      // Plugins adicionais
      //extraPlugins: '',
      // Embed provider
      embed_provider:
        '//ckeditor.iframe.ly/api/oembed?api_key=' +
        iframelyKey +
        '&url={url}&callback={callback}&language=pt-BR&iframe=0&consent=0',
      // Idioma
      language: 'pt-br',
      // Altura do editor
      height: 200,
      // Distância da indentação
      indentOffset: 20,
      // Opções do formato do texto
      format_tags: 'p;h2;h3',
      // Tamanho das fontes
      fontSize_sizes: '12/12px;14/14px;16/16px;18/18px;',
      // Configurações do plugin 'autogrow'
      autoGrow_minHeight: 200,
      autoGrow_maxHeight: 500,
      autoGrow_onStartup: true,
      // Configurações do plugin 'image2'
      image2_captionedClass: 'img',
      image2_alignClasses: ['align-left', 'align-center', 'align-right'],
      // Código para upload de imagens
      filebrowserUploadUrl: urlBase + 'plugins/ckeditor/ck_upload.php',
      filebrowserUploadMethod: 'form',
      // Conteúdo permitido (HTML)
      extraAllowedContent: 'style;*[id];*(*);*{*};hr',
      // Codemirror
      codemirror: {
        showSearchButton: false,
        showFormatButton: false,
        showCommentButton: false,
        showUncommentButton: false,
        showAutoCompleteButton: false,
      },
      // Eventos
      on: {
        // Quando o plugin é carregado
        instanceReady: function () {
          $('textarea.cke-input[data-cke-required]').attr('required', '');
          $.each(CKEDITOR.instances, function (instance) {
            const textarea = $('#' + instance);
            const instanceItem = CKEDITOR.instances[instance];
            // Campos obrigatórios (Parsley)
            instanceItem.on('change', function (e) {
              instanceItem.updateElement();
              textarea.parsley().validate();
            });
          });
        },
      },
    };

    // Configurações do dialog
    CKEDITOR.on('dialogDefinition', function (ev) {
      const dialogName = ev.data.name;
      const dialogDefinition = ev.data.definition;
      // Atributos padrões para as tabelas
      if (dialogName === 'table') {
        // Altera a largura padrão para 100%
        const infoTab = dialogDefinition.getContents('info');
        const txtWidth = infoTab.get('txtWidth');
        txtWidth['default'] = '100%';
        // Altera o cellspacing padrão para 0
        const cellSpacing = infoTab.get('txtCellSpace');
        cellSpacing['default'] = '0';
      }
    });

    // Inicializa o plugin
    $CKEditorInputs.each(function () {
      const $CKEditorInput = $(this);
      CKEDITOR.replace($CKEditorInput.attr('id'), CKEditorConfs);
    });

    // Inicializa o plugin (E-mails)
    $CKEditorEmailInputs.each(function () {
      const $CKEditorInput = $(this);
      CKEDITOR.replace($CKEditorInput.attr('id'), CKEditorEmailConfs);
    });
  }
})();
